import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Container, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { logout, roleSelection } from "../store/Login/actions";
import { useDispatch, useSelector } from "react-redux";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AnalysisHeader from "../pages/Analyst/Dashboard/analysisHeader";
import { getAllNotifications } from "../store/Notification/action";
import NotificationsList from "./notifications/notificationsList";
import useOutsideClick from "../commons/useOutsideClick";
import SwitchAccountOutlinedIcon from "@mui/icons-material/SwitchAccountOutlined";
import { Box } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Header = () => {
  const [scrolling, setScrolling] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const checkFirstLogin = localStorage.getItem("FIRST_LOGIN");
  const navigate = useNavigate();

  const isLoggedIn = useSelector((state) => state?.sessionState?.role);
  const uName =
    useSelector((state) => state?.sessionState?.userName) || "user name";
  const companyDisName = useSelector(
    (state) => state?.sessionState?.companyDisplayName
  );

  const acvtiveRoleId = useSelector(
    (state) => state?.sessionState?.activeRoleId
  );
  const roleType = useSelector((state) => state?.sessionState?.role);

  const notificationsList = useSelector(
    (state) => state?.notificationReducer?.allNotifications
  );
  const unreadNotifications = notificationsList.filter(
    (notification) => !notification.readStatus
  );
  const companiesList = useSelector((state) => state?.sessionState?.userList);

  const dispatch = useDispatch();
  const handleLogout = () => {
    logout()(dispatch);
  };
  const notificationRef = useRef(null);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (!checkFirstLogin || roleType === "TRADER") return;
    checkDiscom();
  }, [companiesList]);

  const checkDiscom = () => {
    let check = companiesList?.[0]?.companyRoles?.filter(
      (ele) => ele?.role?.role === "BANKING"
    );

    if (check?.length > 0) {
      let data = companiesList?.[0]?.companyRoles?.filter(
        (ele) => ele?.role?.role === "BANKING"
      )?.[0];
      localStorage.removeItem("FIRST_LOGIN");
      handleChangeRole("", data?.id, data?.role?.role);
    }
  };

  // fixed header when page scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleNotification = () => {
    setShowNotification(!showNotification);
    !showNotification && getAllNotifications()(dispatch);
  };
  useOutsideClick(notificationRef, handleNotification);

  const headerRoleDisplayMapping = {
    CONSUMER: "Consumer",
    UN_VERIFIED_CONSUMER: "Consumer",
    GENERATOR: "Generator",
    UN_VERIFIED_GENERATOR: "Generator",
    ANALYST: "Analyst",
    COMPANY_ADMIN: "Company Admin",
    TRADER: "Trader",
    BANKING: "Banking",
  };

  const headerRoleDisplay =
    (isLoggedIn && headerRoleDisplayMapping[isLoggedIn]) || "";

  const handleChangeRole = (e, roleId, roleName) => {
    if (acvtiveRoleId !== roleId) {
      roleSelection(roleId, navigate)(dispatch);
    }
  };
  return (
    <>
      <Navbar
        expand="lg"
        className={`custom-nav fixed-top ${scrolling ? "scrolling" : ""}`}
      >
        <Container fluid>
          <Navbar.Brand>
            <Link
              to={
                isLoggedIn
                  ? isLoggedIn === "CONSUMER" ||
                    isLoggedIn === "UN_VERIFIED_CONSUMER"
                    ? "/consumer_dashboard"
                    : isLoggedIn === "GENERATOR" ||
                      isLoggedIn === "UN_VERIFIED_GENERATOR"
                    ? "/dashboard"
                    : isLoggedIn === "ANALYST"
                    ? "/analyst_dashboard"
                    : isLoggedIn === "COMPANY_ADMIN"
                    ? "/admin_comp_dashboard"
                    : isLoggedIn === "BANKING"
                    ? "/banking"
                    : "/"
                  : "/"
              }
            >
              <img src="images/gna-logo-2.png" alt="logo" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <div
            style={{
              fontFamily: "sans-serif",
              color: "#34656D",
              display: "flex",
            }}
          >
            {companyDisName && isLoggedIn !== "TRADER"
              ? companyDisName + " - " + headerRoleDisplay
              : headerRoleDisplay}
            {isLoggedIn && isLoggedIn !== "ANALYST" && (
              <NavDropdown
                title={<SwitchAccountOutlinedIcon />}
                id="basic-nav-dropdown"
              >
                <div className="accContainer">
                  {companiesList?.length > 0 &&
                    companiesList?.map((ele) => (
                      <Accordion
                        expanded={expanded === ele?.companyId}
                        onChange={handleChange(ele?.companyId)}
                      >
                        <AccordionSummary style={{ height: "40px" }}>
                          <div className="eachAccDetails">{ele.name}</div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <ul style={{ marginTop: "-20px" }}>
                            {ele?.companyRoles?.map((elem) => (
                              <li
                                className={
                                  acvtiveRoleId === elem?.id
                                    ? "activeRole"
                                    : "inActiveRole"
                                }
                                onClick={(e) => {
                                  handleChangeRole(
                                    e,
                                    elem?.id,
                                    elem?.role?.role
                                  );
                                }}
                              >
                                {elem?.role?.role}
                              </li>
                            ))}
                          </ul>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                </div>
              </NavDropdown>
            )}

            {/* <Box sx={{ minHeight: 100, flexGrow: 1, maxWidth: 300 }}>
         <SimpleTreeView
          aria-label="multi-select"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          multiSelect
         >
          {companiesList?.length > 0 &&
           companiesList?.map((item, i = i + 1) => (
            <TreeItem key={`company-${i}`} nodeId={String(i)} label={item.name}>
             {item?.companyRoles?.map((roleItem, j = j + 2) => (
              <TreeItem
               key={`companyRole-${j + 1}`}
               nodeId={String(roleItem?.id)}
               label={roleItem?.role?.role}
               onClick={(e) => {
                handleChangeRole(e, roleItem?.id, roleItem?.role?.role);
               }}
               disabled={acvtiveRoleId === roleItem?.id}
              />
             ))}
            </TreeItem>
           ))}
         </SimpleTreeView>
        </Box> */}
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            {isLoggedIn ? (
              isLoggedIn === "ANALYST" ? (
                <div className="ms-auto">
                  <AnalysisHeader />
                </div>
              ) : isLoggedIn === "TRADER" || isLoggedIn === "COMPANY_ADMIN" ? (
                <Nav className="ms-auto">
                   <Nav.Link as={NavLink} to="/landing_cost_calculator">
                    Landing Cost Calculator
                  </Nav.Link> 
                  {/* <Nav.Link className="header-nav-items" onClick={handleLogout}>
          Logout
         </Nav.Link> */}
                  <NavDropdown
                    title={
                      uName?.charAt(0).toUpperCase() +
                      uName?.slice(1).toLowerCase()
                    }
                    id="basic-nav-dropdown"
                  >
                    <NavDropdown.Item href="" onClick={handleLogout}>
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </Nav>
              ) : (
                <Nav className="ms-auto">
                  {(isLoggedIn === "GENERATOR" ||
                    isLoggedIn === "CONSUMER") && (
                    <>
                      <Nav.Link
                        as={NavLink}
                        to={
                          isLoggedIn
                            ? isLoggedIn === "CONSUMER"
                              ? "/consumer_dashboard"
                              : isLoggedIn === "GENERATOR"
                              ? "/dashboard"
                              : "/"
                            : "/"
                        }
                        activeclassname="active"
                      >
                        My Listing
                      </Nav.Link>
                      <Nav.Link as={NavLink} to="/search_listings">
                        All Active
                      </Nav.Link>
                    </>
                  )}
                  {isLoggedIn === "BANKING" && (
                    <>
                      <Nav.Link as={NavLink} to="/banking">
                        My Banking
                      </Nav.Link>
                      <Nav.Link as={NavLink} to="/search_banking">
                        Search Banking
                      </Nav.Link>
                      <Nav.Link as={NavLink} to="/banking_ledger">
                        My Ledger
                      </Nav.Link>
                    </>
                  )}
                  <Nav.Link as={NavLink} to="/landing_cost_calculator">
                    Landing Cost Calculator
                  </Nav.Link>
                  <Nav.Link
                    to="/"
                    className="position-relative"
                    onClick={handleNotification}
                  >
                    <NotificationsIcon />
                    {notificationsList?.length > 0 && (
                      <span className="notification-count">
                        {unreadNotifications?.length || 0}
                      </span>
                    )}
                  </Nav.Link>
                  <NavDropdown
                    title={
                      uName?.charAt(0).toUpperCase() +
                      uName?.slice(1).toLowerCase()
                    }
                    id="basic-nav-dropdown"
                  >
                    <NavDropdown.Item as={NavLink} to="/edit_profile">
                      Edit Profile
                    </NavDropdown.Item>
                    <NavDropdown.Item as={NavLink} to="/my_documents">
                      My Documents
                    </NavDropdown.Item>
                    <NavDropdown.Item as={NavLink} to="/capacity_listing">
                      {isLoggedIn === "BANKING" ? "My Banking" : "My Listing"}
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    {/* <NavDropdown.Item as={NavLink} to="/user_guide">
                      User manual
                    </NavDropdown.Item> */}
                    <NavDropdown.Item href="" onClick={handleLogout}>
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </Nav>
              )
            ) : (
              <Nav className="ms-auto">
                <Nav.Link as={NavLink} to="/" activeclassname="active">
                  OTC Platform
                </Nav.Link>
                 <Nav.Link as={NavLink} to="/landing_cost_calculator">
                  Landing Cost Calculator
                </Nav.Link>
                {/* <Nav.Link as={NavLink} to="/about_us">
         About Us
        </Nav.Link>
        <Nav.Link as={NavLink} to="/contact">
         Contact Us
        </Nav.Link>
        <Nav.Link as={NavLink} to="/faqs">
         FAQs
        </Nav.Link> */}
              </Nav>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {showNotification && (
        <div ref={notificationRef}>
          <NotificationsList handleNotification={handleNotification} />
        </div>
      )}
    </>
  );
};

export default Header;
